import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import {
  FiTrendingUp, FiPlus, FiEdit, FiTrash2, FiSend,
  FiUsers, FiEye, FiMousePointer, FiMail, FiBarChart2,
  FiCalendar, FiRefreshCw, FiX, FiCheck
} from 'react-icons/fi';
import { Line, Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto';

function AdminMarketing() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    type: 'email',
    target: 'all',
    subject: '',
    content: '',
    scheduledAt: '',
    status: 'draft'
  });

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      setTimeout(() => {
        setCampaigns([
          {
            id: '1',
            name: 'Bienvenue nouveaux clients',
            type: 'email',
            target: 'new_users',
            subject: 'Bienvenue sur Liberty !',
            sent: 1234,
            opened: 892,
            clicked: 345,
            status: 'completed',
            createdAt: '2024-01-15',
            scheduledAt: '2024-01-15'
          },
          {
            id: '2',
            name: 'Promotion été 2024',
            type: 'email',
            target: 'all_clients',
            subject: 'Profitez de -20% cet été',
            sent: 0,
            opened: 0,
            clicked: 0,
            status: 'scheduled',
            createdAt: '2024-06-01',
            scheduledAt: '2024-06-15'
          }
        ]);
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error('Erreur:', error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      alert('Campagne créée');
      setShowModal(false);
      resetForm();
      loadCampaigns();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      type: 'email',
      target: 'all',
      subject: '',
      content: '',
      scheduledAt: '',
      status: 'draft'
    });
  };

  const stats = {
    total: campaigns.length,
    sent: campaigns.reduce((sum, c) => sum + c.sent, 0),
    opened: campaigns.reduce((sum, c) => sum + c.opened, 0),
    clicked: campaigns.reduce((sum, c) => sum + c.clicked, 0),
    openRate: campaigns.reduce((sum, c) => sum + c.sent, 0) > 0
      ? ((campaigns.reduce((sum, c) => sum + c.opened, 0) / campaigns.reduce((sum, c) => sum + c.sent, 0)) * 100).toFixed(1)
      : 0
  };

  const chartData = {
    labels: campaigns.map(c => c.name),
    datasets: [{
      label: 'Emails envoyés',
      data: campaigns.map(c => c.sent),
      backgroundColor: 'rgba(234, 179, 8, 0.6)',
      borderColor: 'rgba(234, 179, 8, 1)',
      borderWidth: 1
    }]
  };

  return (
    <div className="space-y-6 p-6 bg-gray-900 min-h-screen text-gray-100">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center pb-4 border-b border-yellow-600/30">
        <div>
          <h1 className="text-4xl font-extrabold text-yellow-400 mb-2 flex items-center">
            <FiTrendingUp className="w-8 h-8 mr-3" />
            Marketing & Campagnes
          </h1>
          <p className="text-gray-400">Gérez vos campagnes marketing et emails</p>
        </div>
        <button
          onClick={() => {
            resetForm();
            setShowModal(true);
          }}
          className="mt-4 sm:mt-0 px-5 py-2.5 bg-yellow-600 text-gray-900 rounded-lg hover:bg-yellow-500 transition-colors font-semibold flex items-center"
        >
          <FiPlus className="mr-2" />
          Nouvelle campagne
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-yellow-600/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <p className="text-sm font-semibold text-gray-400 uppercase">Total campagnes</p>
            <FiBarChart2 className="w-6 h-6 text-yellow-400" />
          </div>
          <p className="text-4xl font-bold text-yellow-400">{stats.total}</p>
        </div>
        <div className="bg-gradient-to-br from-blue-600/10 to-indigo-600/10 border border-blue-600/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <p className="text-sm font-semibold text-gray-400 uppercase">Emails envoyés</p>
            <FiSend className="w-6 h-6 text-blue-400" />
          </div>
          <p className="text-4xl font-bold text-blue-400">{stats.sent}</p>
        </div>
        <div className="bg-gradient-to-br from-green-600/10 to-emerald-600/10 border border-green-600/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <p className="text-sm font-semibold text-gray-400 uppercase">Taux d'ouverture</p>
            <FiEye className="w-6 h-6 text-green-400" />
          </div>
          <p className="text-4xl font-bold text-green-400">{stats.openRate}%</p>
        </div>
        <div className="bg-gradient-to-br from-purple-600/10 to-pink-600/10 border border-purple-600/30 rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <p className="text-sm font-semibold text-gray-400 uppercase">Clics</p>
            <FiMousePointer className="w-6 h-6 text-purple-400" />
          </div>
          <p className="text-4xl font-bold text-purple-400">{stats.clicked}</p>
        </div>
      </div>

      {/* Chart */}
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-yellow-600/30 rounded-xl p-6">
        <h2 className="text-2xl font-bold text-white mb-6">Performances des campagnes</h2>
        <div className="h-64">
          <Bar data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
        </div>
      </div>

      {/* Campaigns List */}
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-yellow-600/30 rounded-xl overflow-hidden">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-yellow-500"></div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-700">
              <thead className="bg-gray-900">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Nom</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Type</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Cible</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Envoyés</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Ouverts</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Clics</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Statut</th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-gray-300 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-gray-800 divide-y divide-gray-700">
                {campaigns.map((campaign) => (
                  <tr key={campaign.id} className="hover:bg-gray-700/30 transition-colors">
                    <td className="px-6 py-4">
                      <p className="text-white font-semibold">{campaign.name}</p>
                      <p className="text-sm text-gray-400">{campaign.subject}</p>
                    </td>
                    <td className="px-6 py-4">
                      <span className="px-3 py-1 text-xs bg-blue-500/20 text-blue-400 rounded-full border border-blue-500/30">
                        {campaign.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-300">
                      {campaign.target === 'all' ? 'Tous' : campaign.target}
                    </td>
                    <td className="px-6 py-4 text-white">{campaign.sent}</td>
                    <td className="px-6 py-4 text-white">{campaign.opened}</td>
                    <td className="px-6 py-4 text-white">{campaign.clicked}</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
                        campaign.status === 'completed' 
                          ? 'bg-green-500/20 text-green-400 border border-green-500/30'
                          : campaign.status === 'scheduled'
                          ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30'
                          : 'bg-gray-500/20 text-gray-400 border border-gray-500/30'
                      }`}>
                        {campaign.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex space-x-2">
                        <button className="text-yellow-400 hover:text-yellow-300 p-2">
                          <FiEdit className="w-4 h-4" />
                        </button>
                        <button className="text-red-400 hover:text-red-300 p-2">
                          <FiTrash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-yellow-600/30 rounded-xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-3xl font-bold text-white">Nouvelle campagne</h2>
              <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-white">
                <FiX className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Nom de la campagne *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Type *</label>
                  <select
                    value={formData.type}
                    onChange={(e) => setFormData({...formData, type: e.target.value})}
                    className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
                  >
                    <option value="email">Email</option>
                    <option value="sms">SMS</option>
                    <option value="push">Notification Push</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Cible *</label>
                  <select
                    value={formData.target}
                    onChange={(e) => setFormData({...formData, target: e.target.value})}
                    className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
                  >
                    <option value="all">Tous les utilisateurs</option>
                    <option value="new_users">Nouveaux utilisateurs</option>
                    <option value="clients">Clients uniquement</option>
                    <option value="movers">Déménageurs uniquement</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Sujet *</label>
                <input
                  type="text"
                  required
                  value={formData.subject}
                  onChange={(e) => setFormData({...formData, subject: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Contenu *</label>
                <textarea
                  required
                  value={formData.content}
                  onChange={(e) => setFormData({...formData, content: e.target.value})}
                  rows="8"
                  className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Date d'envoi</label>
                <input
                  type="datetime-local"
                  value={formData.scheduledAt}
                  onChange={(e) => setFormData({...formData, scheduledAt: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
                />
              </div>
              <div className="flex space-x-4 pt-4">
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-yellow-600 hover:bg-yellow-500 text-gray-900 font-semibold rounded-lg transition-colors"
                >
                  Créer la campagne
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminMarketing;

